import * as angular from 'angular';
import { LayoutPaddingDirective } from './LayoutPaddingDirective';

var layoutPaddingModule = angular.module('app.areas.common.layoutPadding', []);

layoutPaddingModule
    .directive(LayoutPaddingDirective.$name, LayoutPaddingDirective.Factory());

export default layoutPaddingModule.name;
